import {
  colors,
  fonts,
  FontVariants,
  FontWeights,
  font_variant_styles,
} from '@akin-home/theme';
import {
  Text as ReactNativeText,
  TextProps as NativeTextProps,
} from 'react-native';
import styled from 'styled-components/native';

export interface TextProps extends NativeTextProps {
  /**
   * Combinations of variant and weight for brevity
   */
  preset?: keyof typeof presets;

  /** p, h1, h2 etc */
  variant?: FontVariants;

  /** Font weight */
  weight?: FontWeights;

  bold?: boolean;

  italic?: boolean;

  kalam?: boolean;

  color?: string;
}

export const presets = {
  error: `
    font-size: 14px; 
    color: red; 
    font-family: ${fonts.bold};
  `,
  bold: font_variant_styles.p.bold,
  h1: font_variant_styles.h1.bold,
  h2: font_variant_styles.h2.bold,
  h3: font_variant_styles.h3.bold,
  fieldLabel: `font-size: 14px; color: ${colors.grey.dark};`,
  fieldError: `font-size: 14px; color: red`,
  secondary: `color:  ${colors.outline.blue};`,
  dim: `font-size: 9px, color: ${colors.grey.dim};`,
  mealCategory: `
    ${font_variant_styles.p.bold} 
    color: ${colors.orange.crayola};
  `,
  grey: `color: ${colors.grey.dark};`,
  phoneNumber: `
    ${font_variant_styles.p.bold}
    color: ${colors.secondary[900]};`,
  stickyNote: `
    ${font_variant_styles.stickyNote.regular}
  `,
};

/** Base text component used in react-native applications */
export const Text = styled(ReactNativeText)<TextProps>`
  ${font_variant_styles.p.regular}
  color: ${({ color }) => color || colors.grey.dark};
  overflow: visible;
  ${({ preset, weight, variant }) => {
    if (preset) {
      return presets[preset];
    }

    return font_variant_styles[variant || 'p'][weight || 'regular'];
  }}
  ${({ bold }) => (bold ? 'font-weight: bold;' : '')}
  ${({ italic }) => (italic ? 'font-style: italic;' : '')}
  ${({ kalam }) => (kalam ? `font-family: ${fonts.kalam};` : '')}
`;
